import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TimesheetService } from './../../../../core/services/services/timesheet.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject, finalize, forkJoin, of, takeUntil } from 'rxjs';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-monthly-list-cra',
  templateUrl: './monthly-list-cra.component.html',
  styleUrls: ['./monthly-list-cra.component.css'],
})
export class MonthlyListCraComponent {
  currentYear!: number;
  currentUser: any;
  id: any;
  month: any;
  idMonth: any;
  idYear: any;
  listtimesheetForMonths: any;

  private unsubscribeAll: Subject<void> = new Subject();

  constructor(
    private serviceCra: TimesheetService,
    private spinner: NgxSpinnerService,
    private localStorageService: LocalStorageService,
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
    private primengConfig: PrimeNGConfig,
    private router: Router
  ) { }

  ngOnInit(): void {
    forkJoin([this.getCurrentYear(), this.getIdUser(), this.getId()]).subscribe(
      () => {
        this.getListOfTimesheetForMonth();
      }
    );
    this.primengConfig.setTranslation({
      dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
      monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
      today: 'Aujourd\'hui',
      clear: 'Effacer'
    });
  }
  getCurrentYear() {
    const now = new Date();
    this.currentYear = now.getFullYear();
    return of(undefined);
  }

  getIdUser() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.id = JSON.parse(this.currentUser).id;
    return of(undefined);
  }

  getId() {
    return new Observable((observer) => {
      this.activatedRoute.paramMap.subscribe({
        next: (params: any) => {
          this.idMonth = params.params['month'];
          this.idYear = params.params['year'];
          observer.next();
          observer.complete();
        },
        error: (err) => observer.error(err),
      });
    });
  }

  //////////////////////////////date de creation pour afficher dans la liste ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
  formatDate(dateString: string | null): string {
    if (!dateString) {
      return ''; // Gérer le cas où la date est null ou undefined
    }

    const date = new Date(dateString);
    return this.datePipe.transform(date, 'yyyy-MM-dd') || ''; // Gérer le cas où la transformation échoue
  }

  getListOfTimesheetForMonth() {
    let dataPayload = {
      year: this.idYear,
      client_id: this.id,
      month: this.idMonth,
    };

    console.log('yearrrrrrrrrrr', this.currentYear);
    console.log('idddddddddddddddddddddddddd', this.id);

    this.spinner.show();

    this.serviceCra
      .getAllListOfMonths(dataPayload)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe(
        (res: any) => {
          this.listtimesheetForMonths = res?.data[0].timeSheet || [];
          console.log('data listCraForMonths ', this.listtimesheetForMonths);
        },
        (error) => {
          console.error('Error fetching listCraForMonths:', error);
        }
      );
  }

  ///////////////////////////////////////////////////////////////////////////////////////////

  searchListCraForMonth(event?: Event) {
    let automaticSearchCriteria = '';
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.id = JSON.parse(this.currentUser).id;

    let data = {
      year: this.idYear,
      client_id: this.id,
      month: this.idMonth,
      search: automaticSearchCriteria,
    };
    this.spinner.show();
    this.serviceCra
      .searshtimesheetmonth(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('response format:', res);
          this.listtimesheetForMonths = res?.data[0].TimeSheet;
          console.log('');
          this.spinner.hide();
        },
        error: () => {
          console.error('Error during completedAssessment search');
          this.spinner.hide();
        },
      });
  }
  voirListDetailsTimeSheet(id: any) {
    this.router.navigate(['/cra/detail-timesheet', { id: id }]);
  }
}
